import { render, staticRenderFns } from "./DataChooser.vue?vue&type=template&id=360e4e22&scoped=true&"
import script from "./DataChooser.vue?vue&type=script&lang=js&"
export * from "./DataChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360e4e22",
  null
  
)

export default component.exports